import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
 import womanKoder from "../../Assets/womanKoder.png";
import Toolstack from "./Toolstack";

function AboutPage() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Esta  <strong className="purple">soy yo</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
           <img src={womanKoder} alt="about" className="img-fluid" />

          </Col>
        </Row>
        <h1 className="title-heading">
          Mi lista de <strong className="purple">Skillset </strong> profesionales
        </h1>

        <Techstack />

        <h1 className="title-heading">
          Las <strong className="purple">herramientas </strong> que utilizo
        </h1>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default AboutPage;
